import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
export const BILLING_PERIOD_PARAM_NAME = 'interval';
export function useBillingPeriod({ ignoreUrlParams = false } = {}) {
    const searchParams = useSearchParams();
    const isMonthly = !ignoreUrlParams && searchParams.get(BILLING_PERIOD_PARAM_NAME) === 'monthly';
    const billingPeriod = isMonthly ? 'monthly' : 'yearly';
    return {
        billingPeriod,
    };
}
//# sourceMappingURL=useBillingPeriod.js.map